const SentenceStore = {
    assignments: [
        // Assignment#1 - Family Vacation
        [
            {
                sentence_id: 0,
                assignment_id: 0,
                english: "My family went to Ottawa on vacation",
                french: "Ma   famille   est   allée à Ottawa en vacances"
            },
            {
                sentence_id: 1,
                assignment_id: 0,
                english: "It was a fun time",
                french: "Ce fut un moment amusant"
            },
            {
                sentence_id: 2,
                assignment_id: 0,
                english: "I played in the snow",
                french: "J'ai joué dans la neige"
            },
            {
                sentence_id: 3,
                assignment_id: 0,
                english: "It was cold in Ottawa",
                french: "Il faisait froid à Ottawa"
            },
            {
                sentence_id: 4,
                assignment_id: 0,
                english: "I saw my grandparents",
                french: "J'ai vu mes grands-parents"
            },
            {
                sentence_id: 5,
                assignment_id: 0,
                english: "I like to throw snowballs",
                french: "J'aime lancer des boules de neige"
            },
            {
                sentence_id: 6,
                assignment_id: 0,
                english: "Here's a picture of my family",
                french: "Voici une photo de ma famille"
            },
            {
                sentence_id: 7,
                assignment_id: 0,
                english: "I want to go back to see snow again",
                french: "Je veux retourner voir la neige"
            },
            {
                sentence_id: 8,
                assignment_id: 0,
                english: "Thank you!",
                french: "Merci beaucoup!"
            },
        ],
        // Assignment#2 - Famous Person - Lincoln
        [
            {
                sentence_id: 0,
                assignment_id: 1,
                english: "Abraham Lincoln was the 16th President.",
                french: "Abraham Lincoln était le 16e président."
            },
            {
                sentence_id: 1,
                assignment_id: 1,
                english: "He freed the slaves.",
                french: "Il a libéré les esclaves."
            },
            {
                sentence_id: 2,
                assignment_id: 1,
                english: "John Wilkes Booth killed him.",
                french: "John Wilkes Booth l'a tué."
            },
            {
                sentence_id: 3,
                assignment_id: 1,
                english: "It was a plot to start the Civil War again.",
                french: "C'était un complot pour recommencer la guerre civile."
            },
            {
                sentence_id: 4,
                assignment_id: 1,
                english: "Lincoln is on the 5 dollar bill.",
                french: "Lincoln est sur le billet de 5 dollars."
            },
            {
                sentence_id: 5,
                assignment_id: 1,
                english: "We built the Lincoln Memorial to honor Abraham Lincoln.",
                french: "Nous avons construit le Lincoln Memorial en l'honneur d'Abraham Lincoln."
            },
        ],
        // Assignment#3 - Occupation
        [
            {
                sentence_id: 0,
                assignment_id: 2,
                english: "I want to be a lawyer.",
                french: "Je veux être avocat."
            },
            {
                sentence_id: 1,
                assignment_id: 2,
                english: "I want to decide who goes to jail and who doesn’t.",
                french: "Je veux décider qui va en prison et qui ne va pas."
            },
            {
                sentence_id: 2,
                assignment_id: 2,
                english: "I can see if they are dangerous to the world.",
                french: "Je peux voir s'ils sont dangereux pour le monde."
            },
            {
                sentence_id: 3,
                assignment_id: 2,
                english: "I want to keep people safe.",
                french: "Je veux protéger les gens."
            },

        ],
        // Assignment#4 - Favorite Book
        [
            {
                sentence_id: 0,
                assignment_id: 3,
                english: "My favorite book is, Les Oeufs Verts au Jambon.",
                french: "Mon livre favori est, Les Oeufs Verts au Jambon."
            },
            {
                sentence_id: 1,
                assignment_id: 3,
                english: "The book is about having an open mind.",
                french: "Le livre parle d'avoir l'esprit ouvert."
            },
            {
                sentence_id: 2,
                assignment_id: 3,
                english: "I don't like them, Sam-it's me. I don't like green eggs with ham.",
                french: "Je ne les aime pas, Sam-c'est moi.  Je n'aime pas les oeufs verts au jambon."
            },
            {
                sentence_id: 3,
                assignment_id: 3,
                english: "",
                french: ""
            },
            {
                sentence_id: 4,
                assignment_id: 3,
                english: "",
                french: ""
            },
            {
                sentence_id: 5,
                assignment_id: 3,
                english: "- ",
                french: ""
            },

        ],
        // Assignment#5 - Flower, plant or tree
        [
            {
                sentence_id: 0,
                assignment_id: 4,
                english: "My report is on trees.",
                french: "Mon rapport est sur les arbres."
            },
            {
                sentence_id: 1,
                assignment_id: 4,
                english: "Trees are very important for the planet.",
                french: "Les arbres sont très importants pour la planète."
            },
            {
                sentence_id: 2,
                assignment_id: 4,
                english: "Trees provide shelter, and wood.",
                french: "Les arbres fournissent un abri et du bois."
            },
            {
                sentence_id: 3,
                assignment_id: 4,
                english: "You can make axes, houses, and fire from trees.",
                french: "Vous pouvez fabriquer des haches, des maisons et du feu avec des arbres."
            },
            {
                sentence_id: 4,
                assignment_id: 4,
                english: "My favorite tree is a bee tree.",
                french: "Mon arbre préféré est un abeille."
            },
            {
                sentence_id: 5,
                assignment_id: 4,
                english: "Save the trees!",
                french: "Sauver les arbres!"
            },
            {
                sentence_id: 6,
                assignment_id: 4,
                english: "Thank you.",
                french: "Merci."
            },
        ],
        // Assignment#6 - Sport or hobby
        [
            {
                sentence_id: 0,
                assignment_id: 5,
                english: "Assignment 6",
                french: ""
            },
            {
                sentence_id: 1,
                assignment_id: 5,
                english: "My favorite sport is hockey",
                french: "Mon sport préféré est le hockey"
            },
            {
                sentence_id: 2,
                assignment_id: 5,
                english: "My Dad played hockey and I want to play hockey too.",
                french: "Mon père a joué au hockey et je veux jouer au hockey aussi."
            },
            {
                sentence_id: 3,
                assignment_id: 5,
                english: "I am learning how to check and hit.",
                french: "J'apprends à vérifier et à frapper."
            },
            {
                sentence_id: 4,
                assignment_id: 5,
                english: "My family and I like to watch the San Diego Gulls play.",
                french: "Ma famille et moi aimons regarder les Goélands de San Diego jouer."
            },
            {
                sentence_id: 5,
                assignment_id: 5,
                english: "I hope to play hockey soon.",
                french: "J'espère jouer au hockey bientôt."
            },

        ],
        // Assignment#7 - California
        [
            {
                sentence_id: 0,
                assignment_id: 6,
                english: "Assignment 7",
                french: ""
            },
            {
                sentence_id: 1,
                assignment_id: 6,
                english: "My family and I live in California",
                french: "Ma famille et moi vivons en Californie"
            },
            {
                sentence_id: 2,
                assignment_id: 6,
                english: "California is the third largest state in the USA",
                french: "La Californie est le troisième plus grand État des États-Unis"
            },
            {
                sentence_id: 3,
                assignment_id: 6,
                english: "It is the avocado capital of the world.",
                french: "C'est la capitale mondiale de l'avocat."
            },
            {
                sentence_id: 4,
                assignment_id: 6,
                english: "It has lots of beaches",
                french: "Il y a beaucoup de plages"
            },
            {
                sentence_id: 5,
                assignment_id: 6,
                english: "California is a great place to live.",
                french: "La Californie est un endroit formidable où vivre."
            },
        ],
        // Assignment#8 - Summer Plans
        [
            {
                sentence_id: 0,
                assignment_id: 7,
                english: "Assignment 8",
                french: ""
            },
            {
                sentence_id: 1,
                assignment_id: 7,
                english: "Make sure Covid is over.",
                french: "M'asuré que Covid est fini."
            },
            {
                sentence_id: 2,
                assignment_id: 7,
                english: "Learn how to skateboard.",
                french: "Apprenez à faire du skateboard."
            },
            {
                sentence_id: 3,
                assignment_id: 7,
                english: "Go rock climbing.",
                french: "Faites de l'escalade."
            },
            {
                sentence_id: 4,
                assignment_id: 7,
                english: "Play sports with my family.",
                french: "Faire du sport avec ma famille."
            },
            {
                sentence_id: 5,
                assignment_id: 7,
                english: "Go to the beach and learn to surf.",
                french: "Alé à la plage et apprendre à surfer."
            },
        ],
        // Assignment#9 - Free choice!
        [
            {
                sentence_id: 0,
                assignment_id: 8,
                english: "Assignment 9 - Fortnite",
                french: ""
            },
            {
                sentence_id: 1,
                assignment_id: 8,
                english: "My topic is about Fortnite",
                french: "Mon sujet concerne Fortnite"
            },
            {
                sentence_id: 2,
                assignment_id: 8,
                english: "It is a fun game and I can play it on the phone.",
                french: "C'est un jeu amusant et je peux y jouer au téléphone."
            },
            {
                sentence_id: 3,
                assignment_id: 8,
                english: "There are great skins.",
                french: "Il y a de super po."
            },
            {
                sentence_id: 4,
                assignment_id: 8,
                english: "I hope the rift are brought back.",
                french: "J'espère que la faille est ramenée."
            },
            {
                sentence_id: 5,
                assignment_id: 8,
                english: "The rift is used to move to different places.",
                french: "La faille me fait bouger dans des endroi."
            },
            {
                sentence_id: 6,
                assignment_id: 8,
                english: "It is a great game to play.",
                french: "C'est un jeu génial à jouer."
            },
            {
                sentence_id: 7,
                assignment_id: 8,
                english: "Thank you",
                french: "Merci"
            }

        ]
    ],

    methods: {
        _getSentenceCount(assignment_id) {
            return SentenceStore.assignments[assignment_id].length;
        },
        _getAssignmentCount(assignment_id) {
            return SentenceStore.assignments.length;
        },
        _getEnglishSentence(assignment_id, sentence_id) {
            return this._getSentence(assignment_id, sentence_id, "e");
        },
        _getFrenchSentence(assignment_id, sentence_id) {
            return this._getSentence(assignment_id, sentence_id, "f");
        },
        _getSentence(assignment_id, sentence_id, language) {
            if ((sentence_id < 0) || (sentence_id >= this._getSentenceCount(assignment_id))) return "";
            if (language == "e")
                return SentenceStore.assignments[assignment_id][sentence_id].english;
            if (language == "f")
                return SentenceStore.assignments[assignment_id][sentence_id].french;
        },
        _store() {
            let itemsToStore = JSON.stringify(SentenceStore.assignments);
            globalThis.localStorage.setItem("assignments", itemsToStore);
        },
        _load() {
            let itemsToStore = globalThis.localStorage.getItem("assignments");
            let assignments = JSON.parse(itemsToStore);
            SentenceStore.assignments = assignments;
            return assignments;
        }
    }
};

let assignments = SentenceStore.assignments;
let methods = SentenceStore.methods;

export { assignments, methods };